import React from 'react';
import { Icon } from './Icon.js';
export const IconMediaStopFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "M3.75 11C2.23122 11 1 9.76878 1 8.25V3.75C1 2.23122 2.23122 1 3.75 1L8.25 1C9.76878 1 11 2.23122 11 3.75V8.25C11 9.76878 9.76878 11 8.25 11H3.75Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconMediaStopFill12.js.map